import { css } from 'glamor';

export const Fade = css.keyframes({
  '0%': { opacity: 0 },
  '100%': { opacity: 1 },
});
